import { createRouter, createWebHashHistory } from 'vue-router'
import store from '../store/'
import Recover from '../views/Recover.vue'

const routes = [
    {
        path: '/',
        redirect: '/recover'
    },
    {
        path: '/:config?',
        name: 'Recover',
        component: Recover
    },
    {
        path: '/recover:config?',
        name: 'Recover',
        component: Recover
    },
    {
        path: '/change:config?',
        name: 'Change',
        // route level code-splitting
        // this generates a separate chunk (change.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "change" */ '../views/Change.vue')
    },
    {
        path: '/success',
        name: 'Success',
        // route level code-splitting
        // this generates a separate chunk (change.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "success" */ '../views/Success.vue'),
        props: true
    },
    {
        path: '/error',
        name: 'Error',
        // route level code-splitting
        // this generates a separate chunk (change.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "error" */ '../views/Error.vue'),
        props: true
    },

]

const router = createRouter({
    history: createWebHashHistory(),
    routes
})

router.beforeEach(async (to, from, next) => {
    if (to.name && ['Recover', 'Change', 'Success', 'Error'].includes(to.name)) {
        if ('config' in to.params && to.params.config) {
            store.dispatch('setConfig', to.params.config)
        }
        if (to.name == 'Success' && !store.state.success) {
            next('/recover')
        } else {
            next()
        }
    } else {
        next('/recover')
    }
})

export default router
